import { HEADER_TO_PLOT_PX, SPAN_PILL_HEIGHT_PX } from "../layout/plot-geometry";
import type { PlotLayout } from "../layout/plot-layout";

export const BAND_HEIGHT_PX = 12;
/** Keeps the plot's bottom border off the band's top row. */
export const PLOT_TO_BAND_GAP_PX = 1;

export const PILL_ROW_GAP_PX = 2;
/** The row a span pill takes over a band above the plot. Under a band below, the pill shares the tick label row. */
export const SPAN_PILL_ROW_PX = SPAN_PILL_HEIGHT_PX + PILL_ROW_GAP_PX;
/** Above the band the pill overlaps the gap under the header, so only the remainder is reserved. */
export const BAND_ABOVE_RESERVE_PX = Math.max(SPAN_PILL_ROW_PX - HEADER_TO_PLOT_PX, 0);

export const MIN_BAR_PX = 2;
/** A span shorter than this on screen still hovers as this wide. */
export const MIN_HIT_PX = 8;
export const BAR_RADIUS_PX = 2;
/** Keeps a bar's border inside the band instead of on the plot's baseline. */
export const BAR_INSET_PX = 1;

export const ACTUAL_COLOR = "#2F6FB6";
export const SCHEDULED_FILL = "#D5E3F3";
export const SCHEDULED_BORDER = "rgba(47, 111, 182, 0.55)";
export const SCHEDULED_BORDER_PX = 1;
export const BAND_BACKGROUND = "#F1F3F4";
export const SCHEDULED_HIGHLIGHT = "rgba(47, 111, 182, 0.08)";
export const ACTUAL_HIGHLIGHT = "rgba(47, 111, 182, 0.14)";

type BandRowBox = { top: number; height: number } | { bottom: number; height: number };

/** The band's box inside the plot container, for DOM pieces drawn on its row. */
export function bandRowBox(layout: PlotLayout, position: "above" | "below"): BandRowBox {
    return position === "below"
        ? { bottom: layout.xAxisBandPx, height: BAND_HEIGHT_PX }
        : { top: BAND_ABOVE_RESERVE_PX, height: BAND_HEIGHT_PX };
}
